module.exports = __webpack_public_path__ + "static/livesync_icon-1f7b563fb45c51d5fa5c6d5e34fd32c4.png";